import React from 'react'
import { ConfirmationDialog } from 'common/styleguide/ConfirmationDialog'
import { useFormatMessage, commonCTAs } from 'lib/localization'

export const PlannerConfirmModal = (props) => (
  <Base
    cancelText={commonCTAs.cancel}
    {...props}
  />
)

export const PlannerAlertModal = (props) => (
  <Base
    cancelText={commonCTAs.close}
    {...props}
  />
)

const Base = ({ cancelText, msg, cb, onRequestClose }) => {
  const fm = useFormatMessage()
  const onConfirm = () => {
    cb && cb()
    onRequestClose()
  }
  return (
    <ConfirmationDialog
      showCloseButton
      onRequestClose={onRequestClose}
      onCancel={onRequestClose}
      cancelText={fm(commonCTAs.close)}
      onConfirm={onConfirm}
      maxWidth='600px'
    >
      {msg}
    </ConfirmationDialog>
  )
}
